import { type FileTransferConfig } from "@istari-frontend/resource/model";
import { createAsyncLimiter, getEnv } from "@istari-frontend/shared";

import { DEFAULT_FILE_TRANSFER_CONFIG, parseFileTransferConfig } from "~/resource/core/file-transfer-policy";

const environmentKeys = {
  uploadConcurrency: "VITE_FILE_UPLOAD_CONCURRENCY",
  contentConcurrency: "VITE_FILE_CONTENT_CONCURRENCY",
  previewMaxBytes: "VITE_FILE_PREVIEW_MAX_BYTES",
  diffMaxBytes: "VITE_FILE_DIFF_MAX_BYTES",
  downloadMaxBytes: "VITE_FILE_DOWNLOAD_MAX_BYTES",
  zipMaxBytes: "VITE_FILE_ZIP_MAX_BYTES",
  zipMaxFiles: "VITE_FILE_ZIP_MAX_FILES",
} as const;

const configuredValues = Object.fromEntries(
  Object.entries(environmentKeys).map(([key, environmentKey]) => [key, getEnv(environmentKey)]),
);

export const fileTransferConfig: Readonly<FileTransferConfig> = Object.freeze(
  parseFileTransferConfig(configuredValues),
);

Object.entries(environmentKeys).forEach(([key, environmentKey]) => {
  const value = configuredValues[key];
  if (value === undefined || value.trim() === "") return;
  const parsed = Number(value);
  if (/^\d+$/.test(value.trim()) && Number.isSafeInteger(parsed) && parsed > 0) return;
  const defaultValue = DEFAULT_FILE_TRANSFER_CONFIG[key as keyof FileTransferConfig];
  console.info(`Invalid ${environmentKey}; using default ${defaultValue}.`);
});

export const uploadQueue = createAsyncLimiter(fileTransferConfig.uploadConcurrency);
export const readContentQueue = createAsyncLimiter(fileTransferConfig.contentConcurrency);
